<template>
  <div>

    <!-- Loading skeleton -->
    <div v-if="!Object.keys(pricing).length" class="pl-loading">
      <div class="pl-spinner"></div>
      <span>Carregando planos…</span>
    </div>

    <template v-else>

      <!-- ─── Header ─── -->
      <div class="pl-header">
        <div class="pl-header-tag">Assinatura</div>
        <h2 class="pl-header-title">Planos e Preços</h2>
        <p class="pl-header-sub">Escolha o plano ideal para o seu negócio</p>
      </div>

      <!-- ─── Cards ─── -->
      <div class="pl-cards">

        <!-- Current plan -->
        <div class="pl-card pl-card-current">
          <div class="pl-card-badge pl-badge-current">
            <svg width="11" height="11" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
            Plano atual
          </div>
          <div class="pl-card-name">{{ pricing.basicPlan.title }}</div>
          <div class="pl-card-sub">{{ pricing.basicPlan.subtitle }}</div>

          <div class="pl-price-row">
            <span class="pl-currency">R$</span>
            <span class="pl-price">{{ pricing.basicPlan.monthlyPrice }}</span>
            <span class="pl-period">/mês</span>
          </div>

          <ul class="pl-features">
            <li v-for="(item, i) in pricing.basicPlan.planBenefits" :key="i" class="pl-feature pl-feature-current">
              <span class="pl-check pl-check-current">
                <svg width="10" height="10" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
              </span>
              {{ item }}
            </li>
          </ul>

          <button class="pl-btn pl-btn-current" disabled>
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
            Plano ativo
          </button>
        </div>

        <!-- Upgrade plan -->
        <div class="pl-card pl-card-upgrade">
          <div class="pl-card-badge pl-badge-upgrade">
            <svg width="11" height="11" fill="none" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/></svg>
            Popular
          </div>
          <div class="pl-card-name">{{ pricing.standardPlan.title }}</div>
          <div class="pl-card-sub">{{ pricing.standardPlan.subtitle }}</div>

          <div class="pl-price-row">
            <span class="pl-currency pl-currency-upgrade">R$</span>
            <span class="pl-price pl-price-upgrade">{{ pricing.standardPlan.monthlyPrice }}</span>
            <span class="pl-period">/mês</span>
          </div>

          <ul class="pl-features">
            <li v-for="(item, i) in pricing.standardPlan.planBenefits" :key="i" class="pl-feature pl-feature-upgrade">
              <span class="pl-check pl-check-upgrade">
                <svg width="10" height="10" fill="none" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
              </span>
              {{ item }}
            </li>
          </ul>

          <button
            class="pl-btn pl-btn-upgrade"
            :disabled="valorRetornado === 2"
            @click="apiPlano(plano)"
          >
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Assinar agora
          </button>

          <div class="pl-trial-note">Sem necessidade de cartão de crédito</div>
        </div>

      </div>

      <!-- ─── CTA Banner ─── -->
      <div class="pl-cta">
        <div class="pl-cta-icon">
          <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 8v4l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="pl-cta-text">
          <div class="pl-cta-title">Ainda não está convencido?</div>
          <div class="pl-cta-desc">Comece com uma avaliação gratuita de 30 dias. Acesso total a todos os recursos, sem compromisso.</div>
        </div>
        <button
          class="pl-btn pl-btn-cta"
          :disabled="valorRetornado === 2"
          @click="apiPlano(plano)"
        >
          Começar avaliação gratuita
        </button>
      </div>

    </template>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import PlanoService from '@/services/PlanoUpgrade'

export default {
  directives: { Ripple },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      valorRetornado: '',
      monthlyPlanShow: true,
      pricing: {},
      plano: '',
    }
  },

  mounted() {
    this.buscarDados()
  },

  methods: {
    buscarDados() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.userData.id}`)
        .then(response => response.json())
        .then(response => {
          this.configData(response[0])
          this.valorRetornado = response.length
        })
        .catch(err => console.error(err))
    },

    configData(response) {
      const planBenefitsChatBosster = [
        'Integração com o RD Station',
        'Integração com o Pipedrive',
        'Integração com o Active Campaign',
      ]
      const planBenefitsVSLBosster = [
        'Todos os recursos inclusos',
        '15.000 plays por mês',
        'R$ 0,02 por play extra',
      ]
      const monthlyPriceChatBosster = 86
      const monthlyPriceVSLBosster = 72
      const planoAtual = response.planocontratado
      const planoUpgrade = planoAtual === 'VSL Booster' ? 'CHAT Booster' : 'VSL Booster'
      this.plano = planoUpgrade

      const planAtualBenefits = planoUpgrade === 'CHAT Booster' ? planBenefitsVSLBosster : planBenefitsChatBosster
      const planUpgradeBenefits = planoUpgrade === 'CHAT Booster' ? planBenefitsChatBosster : planBenefitsVSLBosster
      const monthlyPricePlanAtual = planoUpgrade === 'CHAT Booster' ? monthlyPriceVSLBosster : monthlyPriceChatBosster
      const monthlyPriceUpgrade = planoUpgrade === 'CHAT Booster' ? monthlyPriceChatBosster : monthlyPriceVSLBosster

      this.pricing = {
        basicPlan: {
          title: planoAtual,
          subtitle: `Use o ${planoAtual} gratuitamente por 30 dias`,
          monthlyPrice: monthlyPricePlanAtual,
          planBenefits: planAtualBenefits,
        },
        standardPlan: {
          title: planoUpgrade,
          subtitle: 'Experimente por 30 dias sem custo',
          monthlyPrice: monthlyPriceUpgrade,
          planBenefits: planUpgradeBenefits,
          popular: true,
        },
      }
    },

    async apiPlano(plano) {
      const planoService = new PlanoService()
      await planoService.createUpgradePlano(this.userData.id, plano)
        .then(() => {
          this.$swal({
            title: 'Plano atualizado!',
            text: 'Seu plano foi atualizado com sucesso. Aproveite os novos benefícios!',
            icon: 'success',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          })
        })
        .catch(() => {
          this.$swal({
            title: 'Algo deu errado',
            text: 'Não foi possível atualizar seu plano. Tente novamente.',
            icon: 'error',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          })
        })
    },
  },
}
</script>

<style scoped>
/* ─── Loading ─── */
.pl-loading {
  display: flex; flex-direction: column; align-items: center;
  gap: 12px; padding: 60px 24px; color: var(--dk-text-muted, #8a94a6); font-size: 14px;
}
.pl-spinner {
  width: 36px; height: 36px; border-radius: 50%;
  border: 3px solid var(--dk-border-light, #f0f2f5); border-top-color: #E86A10;
  animation: pl-spin 0.9s linear infinite;
}
@keyframes pl-spin { to { transform: rotate(360deg); } }

/* ─── Header ─── */
.pl-header { text-align: center; padding: 28px 24px 8px; }
.pl-header-tag {
  display: inline-block; padding: 4px 14px; border-radius: 20px;
  background: rgba(232,106,16,0.1); color: #E86A10;
  font-size: 11.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em; margin-bottom: 12px;
}
.pl-header-title { font-size: 22px; font-weight: 800; color: var(--dk-text-primary, #0D3349); margin: 0 0 8px; }
.pl-header-sub { font-size: 14px; color: var(--dk-text-muted, #8a94a6); margin: 0; }

/* ─── Cards ─── */
.pl-cards {
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  padding: 20px 24px;
}

.pl-card {
  border-radius: 16px; padding: 24px 22px;
  display: flex; flex-direction: column; gap: 4px;
  position: relative; overflow: visible;
}
.pl-card-current {
  background: var(--dk-bg-inset, #f8f9fc);
  border: 2px solid var(--dk-border-input, #e5e8ef);
}
.pl-card-upgrade {
  background: linear-gradient(145deg, #0D3349 0%, #1a4d6b 100%);
  border: 2px solid transparent;
  box-shadow: 0 12px 36px rgba(13,51,73,0.22);
}

/* Badges */
.pl-card-badge {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 11px; border-radius: 20px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.05em; width: fit-content; margin-bottom: 12px;
}
.pl-badge-current { background: rgba(40,199,111,0.1); color: #1e9957; }
.pl-badge-upgrade { background: #E86A10; color: #fff; }

/* Names */
.pl-card-name { font-size: 18px; font-weight: 800; color: var(--dk-text-primary, #0D3349); margin-bottom: 4px; }
.pl-card-upgrade .pl-card-name { color: #fff; }
.pl-card-sub { font-size: 12.5px; color: var(--dk-text-muted, #8a94a6); margin-bottom: 16px; line-height: 1.4; }
.pl-card-upgrade .pl-card-sub { color: rgba(255,255,255,0.55); }

/* Price */
.pl-price-row { display: flex; align-items: flex-end; gap: 2px; margin-bottom: 20px; }
.pl-currency { font-size: 16px; font-weight: 700; color: var(--dk-text-primary, #344563); padding-bottom: 4px; }
.pl-price { font-size: 42px; font-weight: 900; color: var(--dk-text-primary, #0D3349); line-height: 1; }
.pl-period { font-size: 14px; color: var(--dk-text-faint, #aab0bc); padding-bottom: 6px; margin-left: 2px; }
.pl-currency-upgrade { color: #F5B935; }
.pl-price-upgrade { color: #fff; }
.pl-card-upgrade .pl-period { color: rgba(255,255,255,0.45); }

/* Features */
.pl-features { list-style: none; margin: 0 0 20px; padding: 0; display: flex; flex-direction: column; gap: 10px; flex: 1; }
.pl-feature { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; line-height: 1.4; }
.pl-feature-current { color: var(--dk-text-primary, #344563); }
.pl-feature-upgrade { color: rgba(255,255,255,0.85); }
.pl-check {
  width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; margin-top: 1px;
}
.pl-check-current { background: rgba(40,199,111,0.12); color: #1e9957; }
.pl-check-upgrade { background: rgba(245,185,53,0.2); color: #F5B935; }

/* Buttons */
.pl-btn {
  display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 12px 20px; border-radius: 10px; border: none; cursor: pointer;
  font-size: 14px; font-weight: 700; transition: all 0.15s;
  width: 100%;
}
.pl-btn:disabled { opacity: 0.55; cursor: not-allowed; }

.pl-btn-current {
  background: rgba(40,199,111,0.1); color: #1e9957;
  border: 1.5px solid rgba(40,199,111,0.25);
}

.pl-btn-upgrade {
  background: linear-gradient(135deg, #E86A10, #f08535);
  color: #fff; box-shadow: 0 6px 18px rgba(232,106,16,0.4);
}
.pl-btn-upgrade:hover:not(:disabled) {
  background: linear-gradient(135deg, #cf5e0d, #E86A10);
  box-shadow: 0 8px 22px rgba(232,106,16,0.5);
  transform: translateY(-1px);
}

.pl-trial-note { text-align: center; font-size: 11.5px; color: rgba(255,255,255,0.4); margin-top: 8px; }

/* ─── CTA Banner ─── */
.pl-cta {
  display: flex; align-items: center; gap: 18px;
  margin: 4px 24px 24px;
  padding: 20px 22px;
  background: linear-gradient(135deg, rgba(13,51,73,0.04), rgba(232,106,16,0.06));
  border: 1.5px solid rgba(232,106,16,0.15);
  border-radius: 14px;
  flex-wrap: wrap;
}
.pl-cta-icon {
  width: 48px; height: 48px; border-radius: 12px; flex-shrink: 0;
  background: rgba(232,106,16,0.1); color: #E86A10;
  display: flex; align-items: center; justify-content: center;
}
.pl-cta-text { flex: 1; min-width: 200px; }
.pl-cta-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #0D3349); }
.pl-cta-desc { font-size: 12.5px; color: var(--dk-text-muted, #8a94a6); margin-top: 3px; line-height: 1.4; }
.pl-btn-cta {
  flex-shrink: 0; width: auto; padding: 11px 22px;
  background: linear-gradient(135deg, #E86A10, #f08535);
  color: #fff; box-shadow: 0 4px 14px rgba(232,106,16,0.3);
  white-space: nowrap;
}
.pl-btn-cta:hover:not(:disabled) {
  background: linear-gradient(135deg, #cf5e0d, #E86A10);
  box-shadow: 0 6px 18px rgba(232,106,16,0.4);
}

@media (max-width: 600px) {
  .pl-cards { grid-template-columns: 1fr; }
  .pl-cta { flex-direction: column; align-items: flex-start; }
  .pl-btn-cta { width: 100%; }
}
</style>
